export enum ThemeColorContrast {
  dark = "dark",
  light = "light",
}

export enum ThemeSite {
  cams = "cams",
  aff = "aff",
}
